import { createAsyncThunk } from '@reduxjs/toolkit';
import { shopService } from 'services';
import {
  GetHistoryReceivingResponse,
  ThunkAPI,
  GetHistoryReceivingRequest,
  GetHistoryReceivingError,
  GetHistorySendingResponse,
  GetHistorySendingRequest,
  GetHistorySendingError,
} from 'types';

export const getHistoryReceiving = createAsyncThunk<
  GetHistoryReceivingResponse,
  GetHistoryReceivingRequest,
  ThunkAPI<GetHistoryReceivingError>
>('receivedNotifications/thunk/getHistoryReceiving', async (params, { rejectWithValue }) => {
  try {
    const { data: dataHistoryReceiving } = await shopService.getHistoryReceiving(params);
    return dataHistoryReceiving;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const getHistorySending = createAsyncThunk<
  GetHistorySendingResponse,
  GetHistorySendingRequest,
  ThunkAPI<GetHistorySendingError>
>('receivedNotifications/thunk/getHistorySending', async (params, { rejectWithValue }) => {
  try {
    const { data: dataHistorySending } = await shopService.getHistorySending(params);
    return dataHistorySending;
  } catch (error) {
    return rejectWithValue(error);
  }
});
